import { createContext, useContext } from 'react'

export type View =
  | 'home' | 'dashboard' | 'enquiries' | 'bookings' | 'planning' | 'trips' | 'petty-cash' | 'billing'
  | 'payables' | 'profitability' | 'reports' | 'masters' | 'settings' | 'audit'

export type NavParams = Record<string, string>

interface Nav {
  /** Switch screen, optionally passing a hint (e.g. which report, which audit record). */
  go: (view: View, params?: NavParams) => void
  params: NavParams
}

export const NavContext = createContext<Nav>({ go: () => {}, params: {} })
export const useNav = (): Nav => useContext(NavContext)
